/**
 * guards a picked File before it is put in a FormData.
 *
 * catches the two entries that would otherwise post nothing useful:
 * a missing file (an empty FileList substituted with null/undefined), and a
 * 0-byte file, which uploads an empty multipart part the API cannot tell apart
 * from no file at all.
 *
 * note a File is only a handle - when the OS reclaims the bytes after picking
 * (camera and Downloads temp files, mostly on mobile) the handle still reports
 * its original name and size, so that case only surfaces as a failed request.
 */
export const isUploadableFile = (file) => !!file && !!file.name && !!file.size;

/**
 * lowercased extension of a filename, for logging - safe to send off-device,
 * unlike the filename itself, which patients routinely put names and conditions
 * in. returns 'NONE' when there is no extension to read.
 */
export const getFileExtension = (filename) => {
  if (!filename || !filename.includes('.')) return 'NONE';

  return filename.split('.').pop().toLowerCase().slice(0, 10);
};
